import { create } from 'zustand';

type UeCrossingInfoBannerState = {
  direction?: string;
  folderNumber?: string;
  folderStatusId?: string;
  trailerLoadMode?: string;
  firstSaveDateTime?: string;
  estimatedArrivalTime?: string;
  crossingRequestedDate?: string;
  isRequiresGmrFormality?: boolean;
  hasCrossingInfoBannerBeenSaved: boolean;
};

export const useCrossingInfoBannerState = create<UeCrossingInfoBannerState>(() => ({
  hasCrossingInfoBannerBeenSaved: false,
}));
